import { Outlet } from 'react-router-dom';
import GlobalFooter from '@/components/GlobalFooter';

export default function PublicLayout() {
  return (
    <>
      <Outlet />
      <GlobalFooter />
    </>
  );
}
